<template>
    <el-drawer v-model="showview" title="提现详情" size="60%" @close="closeview">
        <div class="TTL-table top20">
            <el-table :data="drawallist" stripe="true" empty-text="">
                <template v-slot:empty><el-empty description="暂无数据" /></template>
                <el-table-column label="金额类型" align="center">
                    <template #default="scope">
                        <span>{{scope.row.typename}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="提现金额" align="center">
                    <template #default="scope">
                        <span>{{scope.row.price}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="关联订单号" align="center">
                    <template #default="scope">
                        <span>{{scope.row.order_sn}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="关联微信支付单号" align="center">
                    <template #default="scope">
                        <span>{{scope.row.transition_id}}</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </el-drawer>
</template>

<script>

export default {

    props:['view','list'],
    data() {
        return {
            showview:false,
            drawallist:[],
        }
    },

    watch: {

        view(val) {
            this.showview=val;
        },

        list(val) {
            this.drawallist=val;
        },
    },

    methods: {
        closeview() {
            this.showview=false;
            this.drawallist=[];
            this.$emit('finish');
        },
    },

}
</script>
<style scoped>
.ttl-box {display: inline-block;width:100%;height: calc(100% - 40px);padding:20px 0;overflow-y:auto;}
.ttl-box::-webkit-scrollbar {width:0;}
.ttl-box-info {display: inline-flex;justify-content: left;align-items: center;width:100%;padding:15px 0;border-bottom: 1px solid #F5F7FA;}
.ttl-title {font-size:13px;width:33.3%;}
.ttl-status {font-size:13px;width:33.3%;text-align: center;}
.ttl-price {font-size:13px;width:33.3%;text-align: right;font-weight: bold;}
.ttl-price span {font-size:12px;zoom:.8;}
</style>